import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatExternalTransmissionForm} from './NatExternalTransmissionForm'
import {Location} from 'react-router-dom'

interface Props {
    residentUserRepo: NatResidentUserRepo,
    location: Location
}

class NatResidentExternalTransmissionPage extends Component<Props & ResidentPagePropsSet> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props);
    }


    render(): Nullable<ReactElement> {
        return (
                <NatExternalTransmissionForm mode={'resident'} />
        )
    }
}

export default createResidentPage(NatResidentExternalTransmissionPage)

